import { ExtractPropsFromDefinitionVersion } from '@atlassiansox/bxp-definition-sdk';
import { resetStyles } from '@atlassiansox/ads-theme-reset';
import { setGlobalTheme } from '@atlaskit/tokens';

import type definition from '../../definition';
import { rootContainerStyle } from './jsw-interactive-board.styles';
import { BoardHeader } from './board-header';
import { BoardBody } from './board-body';
import { useInteractiveBoardStore } from './state';
import { useEffect } from 'react';
import { CreateIssueModal, SuccessModal } from './components';
import { modalBlanketStyle } from './components/create-issue-modal.styles';
import { SpotlightManager as Spotlight } from './common';
import { SpotlightManagerProvider } from './common/spotlight-provider';
import { AnalyticsContext } from '@atlaskit/analytics-next';

export type ModulePropsV0 = ExtractPropsFromDefinitionVersion<
  typeof definition,
  0
>;

const JswInteractiveBoard = (props: ModulePropsV0) => {
  const messages = props;
  const [{ isTicketModalOpen }, { setMessages }] = useInteractiveBoardStore();

  void setGlobalTheme({
    light: 'light',
    dark: 'dark',
    colorMode: 'dark'
  });

  useEffect(() => {
    void setMessages(messages);
  }, []);

  return (
    <AnalyticsContext
      data={{
        schemaVersion: 1,
        event: 'event', // event verb, in past tense (eg, "clicked")
        eventType: 'UI',
        eventComponent: 'jswInteractiveBoard', // name of component being interacted with, in camelCase
        eventContainer: 'jswInteractiveBoard', // container, in camelCase; eg, component that contains this component within a page
        eventColumn: 'jswInteractiveBoard', // should be bundleInformation or signUpForm
        eventName: 'jswInteractiveBoardEvent',
        label: '', // the text present on the component being clicked (exact text, not camelCase)
        parentLabel: '', // optional, if this is a nested click (exact text, not camelCase)
        uuid: 'jswInteractiveBoard' // required for Magnolia events, unique id for a given component if available
      }}
    >
      <SpotlightManagerProvider>
        <div
          css={[resetStyles, rootContainerStyle]}
          data-testid="jsw-interactive-board"
        >
          <BoardHeader />
          <BoardBody />
          {isTicketModalOpen && (
            <div css={modalBlanketStyle}>
              <CreateIssueModal />
            </div>
          )}
          <SuccessModal />
          <Spotlight />
        </div>
      </SpotlightManagerProvider>
    </AnalyticsContext>
  );
};

export default JswInteractiveBoard;
